import { DataBean } from "../../DataBean";


export class RelationshipClassConstants extends DataBean {

    public async getRelationshipClassConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRelationshipClassConstants_Number", [args]);
    }

}